export const RAPORPROJEK_GET = 'RAPORPROJEK_GET';
export const RAPORPROJEKDETAIL_GET = 'RAPORPROJEKDETAIL_GET';